interface Props {
  className?: string;
  startGame: () => void;
}
const Introduction = ({ className = "", startGame }: Props) => {
  return (
    <div
      className={`absolute rounded-xl inset-0 z-[2000] flex items-center justify-center pointer-events-auto ${className}`}
    >
      <div className="absolute rounded-xl inset-0 backdrop-blur-sm bg-black/20" />
      <div className="relative flex-col justify-center text-center items-center">
        <div>
          <h2 className="text-white font-semibold text-xl text-ceter">
            Press SPACE when the lines enter the green zone.
          </h2>
          <div className="text-white/80 my-3">
            <p>
              <span className="font-semibold uppercase text-base text-green-500 mr-2">
                Success:
              </span>
              Press space in zone
            </p>
            <p>
              <span className="font-semibold uppercase text-base text-red-500 mr-2">
                Fail:
              </span>
              Press space before zone
            </p>
            <p>
              <span className="font-semibold uppercase text-base text-red-500 mr-2">
                Fail:
              </span>
              No press or late press
            </p>
          </div>
        </div>
        <button
          onClick={startGame}
          aria-label="Start game"
          className="relative z-10 px-6 py-4 rounded-2xl text-xl font-semibold bg-white/6 border border-white/10 text-white shadow-2xl backdrop-filter backdrop-brightness-110 transform transition hover:scale-105 active:scale-95"
        >
          Start Game
        </button>
      </div>
    </div>
  );
};

export default Introduction;
